import React from "react";

const Navbar = (props) => {
  const isUkraine = props.type === 'ukraine' ? true : false
  const link_opensea = props.type === "pfp" ? "https://opensea.io/collection/whiterabbitpfp" : props.type === "ukraine" ? "https://opensea.io/collection/white-rabbit-universe" : "https://opensea.io/collection/white-rabbit-by-gate";

  return (
    <div className="top-0 z-50 w-full justify-between flex  px-6 absolute">
      <div className="flex gap-1 pt-7">
        <a href="https://rabbitff.com/">
          <img src="/logo.png" alt="logo" className="h-20" />
        </a>
        <div className="flex flex-col text-black text-xl break-all justify-center">
          <img src={isUkraine ? "/logo_white.png" : "/top_logo.svg"} alt="small logo" />
          <span className={`mt-1 ${isUkraine ? "text-app-yellow-dark" : ""}`}> #followthewhiterabbit</span>
        </div>
      </div>
      <div className="items-center gap-2 hidden sm:flex ">
        {!isUkraine && (
          <a className="rounded-full p-2 flex items-center justify-center cursor-pointer" href="https://www.instagram.com/whiterabbitbygate" target="_blank" rel="noreferrer">
            <img src={`/icons/instagram_bg.svg`} alt="social icon" className="w-9 h-9" />
          </a>
        )}
        <a className="rounded-full p-2 flex items-center justify-center cursor-pointer" href="https://bit.ly/31iC9oK" target="_blank" rel="noreferrer">
          <img src={`/icons/ico_discord${isUkraine ? "_yellow" : ""}.svg`} alt="discord icon" className="w-9 h-9" />
        </a>
        <a className="rounded-full p-2 flex items-center justify-center cursor-pointer" href={link_opensea} target="_blank" rel="noreferrer">
          <img src={`/icons/ico_opensea${isUkraine ? "_yellow" : ""}.svg`} alt="opensea icon" className="w-9 h-9" />
        </a>
        <a className="rounded-full p-2 flex items-center justify-center cursor-pointer" href="https://twitter.com/WhiteRabbitGATE" target="_blank" rel="noreferrer">
          <img src={`/icons/ico_twitter${isUkraine ? "_yellow" : ""}.svg`} alt="twitter icon" className="w-9 h-9" />
        </a>
      </div>
    </div>
  );
};

export default Navbar;
